import React from 'react';
import { theme } from '../../styles/theme';

const Card = ({
  children,
  hover = false,
  padding = 'md',
  shadow = 'sm',
  variant = 'default',
  onClick,
  style = {},
  ...props
}) => {
  const paddingValues = {
    none: '0',
    sm: theme.spacing.sm,
    md: theme.spacing.md,
    lg: theme.spacing.lg,
    xl: theme.spacing.xl,
  };

  const shadowValues = {
    none: 'none',
    sm: theme.shadows.sm,
    md: theme.shadows.md,
    lg: theme.shadows.lg,
  };

  const variantStyles = {
    default: {
      backgroundColor: theme.colors.surface,
      border: `1px solid ${theme.colors.borderLight}`,
    },
    outlined: {
      backgroundColor: theme.colors.surface,
      border: `2px solid ${theme.colors.border}`,
    },
    elevated: {
      backgroundColor: theme.colors.surface,
      border: `1px solid ${theme.colors.borderLight}`,
      boxShadow: theme.shadows.md,
    },
    parchment: {
      backgroundColor: theme.colors.surfaceAlt,
      border: `1px solid ${theme.colors.border}`,
    },
  };

  const baseStyles = {
    borderRadius: theme.borderRadius.lg,
    padding: paddingValues[padding],
    boxShadow: shadowValues[shadow],
    transition: theme.transitions.base,
    cursor: onClick ? 'pointer' : 'default',
    ...variantStyles[variant],
    ...style,
  };

  const hoverStyles = hover || onClick ? {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows.md,
  } : {};

  return (
    <div
      onClick={onClick}
      style={baseStyles}
      onMouseEnter={(e) => {
        if (hover || onClick) {
          Object.assign(e.currentTarget.style, hoverStyles);
        }
      }}
      onMouseLeave={(e) => {
        if (hover || onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = shadowValues[shadow];
        }
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;

